import { NavItem } from '../models/navItem';

export const navigationData: NavItem[] = [
  {
    "displayName": "Administration",
    "iconName": "settings",
    "children": [
      {
        "displayName": "Users",
        "iconName": "people",
        "route": "users"
      },
      {
        "displayName": "Customers",
        "iconName": "groups",
        "route": "customers"
      },
      {
        "displayName": "Login Attempts",
        "iconName": "security",
        "route": "login-attempts"
      },
      {
        "displayName": "App Settings",
        "iconName": "tune",
        "route": "app-settings/active-year"
      },
      // {
      //   "displayName": "Tasks (Universities)",
      //   "iconName": "assignment",
      //   "route": "/administration/tasks-universities"
      // },
      // {
      //   "displayName": "Predefined Tasks",
      //   "iconName": "rule",
      //   "route": "/administration/predefined-tasks"
      // }
    ]
  },
  {
    "displayName": "Companies",
    "iconName": "business",
    "children": [
      {
        "displayName": "Companies List",
        "iconName": "business",
        "route": "companies/list",
        "activeOn": ["companies/create", "companies/edit"]
      },
      {
        "displayName": "Opb Companies List",
        "iconName": "api",
        "route": "companies/opb-list",
        "activeOn": ["companies/opb-create", "companies/opb-edit"]
      },
      {
        "displayName": "Countries Setup",
        "iconName": "tune",
        "route": "/companies/countries-setup"
      },
      {
        "displayName": "Industries",
        "iconName": "insights",
        "route": "/configuration/industries"
      },
      {
        "displayName": "Indices",
        "iconName": "insights",
        "route": "/configuration/indices"
      }
    ]
  },
  {
    "displayName": "Directors",
    "iconName": "groups",
    "children": [
      {
        "displayName": "Directors List",
        "iconName": "settings_applications",
        "route": "directors/list",
        "activeOn": ["directors/create", "directors/edit"]
      },
      {
        "displayName": "Professions",
        "iconName": "work_outline",
        "route": "directors/professions"
      },
      {
        "displayName": "Industry Expertise",
        "iconName": "factory",
        "route": "directors/industry-expertises"
      },
      {
        "displayName": "Financial Expertise",
        "iconName": "account_balance_wallet",
        "route": "directors/financial-expertises"
      },
      {
        "displayName": "Political Positions",
        "iconName": "how_to_vote",
        "route": "directors/political-positions"
      },
      {
        "displayName": "Honorific Titles",
        "iconName": "badge",
        "route": "directors/honorific-titles"
      },
      {
        "displayName": "Qualifications",
        "iconName": "star_rate",
        "route": "directors/qualifications"
      },
      {
        "displayName": "Education Fields",
        "iconName": "school",
        "route": "directors/education-fields"
      },
      {
        "displayName": "Universities",
        "iconName": "school",
        "route": "directors/universities"
      },
      {
        "displayName": "Job Positions",
        "iconName": "assignment_ind",
        "route": "directors/job-positions"
      },
      {
        "displayName": "Work Experience Companies",
        "iconName": "business_center",
        "route": "directors/work-experience-companies"
      }
    ]
  },
  {
    "displayName": "Large Shareholders",
    "iconName": "insights",
    "children": [
      {
        "displayName": "Large Shareholders List",
        "iconName": "settings_applications",
        "route": "/large-shareholders/list",
        "activeOn": ["/large-shareholders/create", "/large-shareholders/edit"]
      },
      {
        "displayName": "Categories",
        "iconName": "settings_applications",
        "route": "/large-shareholders/categories"
      },
      {
        "displayName": "Pyramidal Shareholders List",
        "iconName": "settings_applications",
        "route": "/pyramidal-shareholders/list"
      }
    ]
  },
  {
    "displayName": "Audit",
    "iconName": "fact_check",
    "children": [
      {
        "displayName": "Accounting Standards",
        "iconName": "rule_folder",
        "route": "audit/accounting-standards"
      },
      {
        "displayName": "Opinion",
        "iconName": "gavel",
        "route": "audit/audit-opinions"
      },
      {
        "displayName": "Opinion Modified",
        "iconName": "edit_note",
        "route": "audit/audit-opinion-modifieds"
      },
      {
        "displayName": "Opinion Qualified",
        "iconName": "unpublished",
        "route": "audit/audit-opinion-qualified-options"
      },
      {
        "displayName": "Emphasis of Matters",
        "iconName": "campaign",
        "route": "audit/audit-emphasis-of-matters"
      },
      {
        "displayName": "Going Concern",
        "iconName": "report_problem",
        "route": "audit/audit-going-concerns"
      },
      {
        "displayName": "Key Audit Matters",
        "iconName": "fact_check",
        "route": "audit/audit-key-matters"
      },
      {
        "displayName": "Materiality",
        "iconName": "scale",
        "route": "audit/audit-materiality"
      },
      {
        "displayName": "Audit Fees Categories",
        "iconName": "paid",
        "route": "audit/audit-fee-categories"
      },
      {
        "displayName": "Audit Firms",
        "iconName": "business_center",
        "route": "audit/audit-firms"
      },
      {
        "displayName": "Section Configuration",
        "iconName": "shield_with_house",
        "route": "audit/audit-section-configuration"
      }
    ]
  },
  {
    "displayName": "Corporate Governance",
    "iconName": "gavel",
    "children": [
      {
        "displayName": "Committees",
        "iconName": "corporate_fare"
      },
      {
        "displayName": "Stock Categories",
        "iconName": "inventory_2",
        "route": "/corporate-governance/stock-categories"
      },
      {
        "displayName": "Stock Coefficients",
        "iconName": "percent",
        "route": "/corporate-governance/stock-coefficients"
      },
      {
        "displayName": "Classifications",
        "iconName": "label_important"
      },
      {
        "displayName": "Occupations",
        "iconName": "work_history",
        "route": "/corporate-governance/occupations"
      },
      {
        "displayName": "Deregistration Reasons",
        "iconName": "business_off",
        "route": "/corporate-governance/company-deregistration-reasons"
      },
      {
        "displayName": "CEO Turnover Reasons",
        "iconName": "swap_horiz",
        "route": "/corporate-governance/ceo-turnover-reasons"
      }
    ]
  },
  {
    "displayName": "Family Firms",
    "iconName": "family_restroom",
    "children": [
      {
        "displayName": "Family Company Statuses",
        "iconName": "settings_applications",
        "route": "/family-firms/family-company-statuses"
      },
      {
        "displayName": "Family Generations",
        "iconName": "groups",
        "route": "/family-firms/family-generations"
      }
    ]
  },
  {
    "displayName": "Compensation",
    "iconName": "payments",
    "children": [
      {
        "displayName": "Category Configuration",
        "iconName": "category",
        "route": "/compensation/category-configuration"
      },
      {
        "displayName": "Consultant Firms",
        "iconName": "business_center",
        "route": "/compensation/consultant-firms"
      },
      {
        "displayName": "Occupations",
        "iconName": "work_outline",
        "route": "/compensation/occupations"
      },
      {
        "displayName": "Standards",
        "iconName": "verified",
        "route": "/compensation/standards"
      },
      {
        "displayName": "Multiplier",
        "iconName": "functions",
        "route": "/compensation/multipliers"
      }
    ]
  },
  {
    "displayName": "ESG",
    "iconName": "eco",
    "children": [
      {
        "displayName": "Standards",
        "iconName": "fact_check",
        "route": "/csr/standards"
      },
      {
        "displayName": "Assurance Providers",
        "iconName": "verified_user",
        "route": "/csr/assurance-providers"
      },
      {
        "displayName": "Measurement Units",
        "iconName": "straighten",
        "route": "/csr/measurement-units"
      },
      {
        "displayName": "Country - Capitalization",
        "iconName": "assessment",
        "route": "/csr/country-capitalization"
      }
    ]
  },
  {
    "displayName": "Voting Results",
    "iconName": "how_to_vote",
    "children": [
      {
        "displayName": "Voting Results List",
        "iconName": "view_in_ar",
        "route": "/voting-results/list"
      },
      {
        "displayName": "Categories",
        "iconName": "label_important_outline",
        "route": "/voting-results/categories"
      },
      {
        "displayName": "Options",
        "iconName": "settings",
        "route": "/voting-results/options"
      },
      {
        "displayName": "Shareholder Proposal Names List",
        "iconName": "edit_note",
        "route": "/voting-results/shareholder-proposal-names/list",
        "activeOn": ["/voting-results/shareholder-proposal-names/create", "/voting-results/shareholder-proposal-names/edit"]
      }
    ]
  },
  {
    "displayName": "Control Panel",
    "iconName": "tune",
    "children": [
      {
        "displayName": "Automatic Correction",
        "iconName": "auto_fix_high",
        "route": "automatic-correction"
      },
      {
        "displayName": "Check Family",
        "iconName": "group_work",
        "route": "check-family-status"
      },
      {
        "displayName": "Check Corporate Governance",
        "iconName": "domain_verification",
        "route": "check-corporate-governance"
      },
      {
        "displayName": "Error Detection",
        "iconName": "error_outline"
      },
      {
        "displayName": "Entry Supervision",
        "iconName": "plagiarism",
        "route": "session-reports"
      },
      {
        "displayName": "Deviation Check",
        "iconName": "compare_arrows",
        "route": "divcheck"
      },
      {
        "displayName": "Query Management",
        "iconName": "contact_support"
      },
      {
        "displayName": "Customer Reports",
        "iconName": "table_chart",
        "route": "customer-report-cells"
      },
      {
        "displayName": "Audit Log",
        "iconName": "history",
        "route": "/auditlog",
        "developerOnly": true
      }
    ]
  },
  {
    "displayName": "Issues",
    "iconName": "bug_report",
    "children": [
      {
        "displayName": "Issues List",
        "iconName": "list",
        "route": "issues",
        "activeOn": ["issues/create"]
      },
      {
        "displayName": "Categories",
        "iconName": "category",
        "route": "issue-categories"
      }
    ]
  }
];
